import React from 'react';
import { useNavigate } from 'react-router-dom';
import { List, Menu, Typography, Col, Row, Avatar } from 'antd';
import { UnorderedListOutlined, PlusOutlined, SearchOutlined, StarOutlined } from '@ant-design/icons';
import PortfolioSquare from "./PortfolioSquare";

const { SubMenu } = Menu;

const PortfolioList = ({ portfolios, menuLetter='M' }) => {
    const navigate = useNavigate();

    const handleNavigate = (portfolioId) => {
        navigate(`/public/portfolio/${portfolioId}`);
    };

    return (
        <Row justify={'space-between'}>
            <Menu
                mode="inline"
                style={{ width: 200, border: 'none' }}
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
            >
                <SubMenu
                    key="sub1"
                    icon={<Avatar style={{background: 'linear-gradient(to bottom right, #B44C8D, #D768AD)', borderRadius: 8, color: "#FFF"}}>{menuLetter}</Avatar>}
                    title="Models"
                >
                    <Menu.Item key="1" icon={<StarOutlined />}>
                        Active
                    </Menu.Item>
                    <Menu.Item key="2" icon={<PlusOutlined />}>
                        Create
                    </Menu.Item>
                    <Menu.Item key="3" icon={<SearchOutlined />}>
                        Find
                    </Menu.Item>
                </SubMenu>
            </Menu>

            <List
                grid={{
                    gutter: 16,
                    column: 1
                }}
                style={{ width: 250, height: 400, overflowY: 'scroll' }}

                dataSource={portfolios}
                renderItem={portfolio => (
                    <List.Item>
                        <PortfolioSquare portfolio={portfolio} height={230} width={200} />
                    </List.Item>
                )}
            />
        </Row>
    );
};

export default PortfolioList;
